import { useNavigate } from "react-router-dom";

import useUser from "../../profile/useUser";
import NotificationsPopover from "../../notifications/components/NotificationsPopover";
import CartButton from "./CartButton";
import ProfileAvatar from "./ProfileAvatar";

const UtilityBar = () => {
  const navigate = useNavigate();
  const { isAuthenticated, displayName } = useUser();

  return (
    <div className="sy-utility-bar">
      <div className="sy-utility-inner">
        {isAuthenticated ? (
          <div className="sy-account-group">
            <NotificationsPopover variant="dot" />
            <CartButton />
            <span className="sy-account-name">{displayName}</span>
            <ProfileAvatar />
          </div>
        ) : (
          <>
            <button
              type="button"
              className="sy-utility-link sy-utility-link--signin"
              onClick={() => navigate("/auth")}
            >
              Sign In | Up
            </button>
            <CartButton />
          </>
        )}
      </div>
    </div>
  );
};

export default UtilityBar;
